module.exports = __webpack_public_path__ + "media/images/fire-full-icon-8b90c294c1b88b2aba002033f8e46458.svg";